<template>
  <div>
    <DialogComponent
      ref="dialog"
      type="fullscreen"
      noInnerPadding
      hideCloseButton
    >
      <FiltersPage @close="() => $refs.dialog.hide()" />
    </DialogComponent>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue';
import FiltersPage from './components/FiltersPage.vue';

const dialog = ref(null);
const { proxy } = getCurrentInstance();
const { $constants, $bus } = proxy;

const showDialog = () => {
  console.log('[FiltersDialog] SHOW_DIALOG event received, opening dialog');
  dialog.value.show();
};

onMounted(() => {
  console.log('[FiltersDialog] Component mounted, setting up event listener');
  console.log('[FiltersDialog] Constants:', $constants?.EVENTS?.SEARCH_FILTERS);
  $bus.on($constants.EVENTS.SEARCH_FILTERS.SHOW_DIALOG, showDialog);
  console.log('[FiltersDialog] Event listener registered for SHOW_DIALOG');
});

onBeforeUnmount(() => {
  $bus.off($constants.EVENTS.SEARCH_FILTERS.SHOW_DIALOG, showDialog);
});
</script>
